import React, { cloneElement } from 'react'
import { useTranslation } from 'react-i18next'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'

import {
  Edit,
  Visibility,
  Restore,
  Delete,
  FileCopy,
} from '@mui/icons-material'
import { colors } from '@/theme/colors.theme'
import { dropdownMenuProps } from '@/constants/mui'

export type TableMenuOptions = 'delete' | 'duplicate' | 'edit' | 'preview'

type Props = {
  canPreview?: boolean
  canEdit?: boolean
  canView?: boolean
  canDelete?: boolean
  canDuplicate?: boolean
  isArchive?: boolean
  anchorEl: HTMLElement | null
  extraOptions?: React.ReactNode
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>
  handleClickButton?: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    type: TableMenuOptions,
  ) => void
}

export const TableMenuComponent = ({
  canPreview,
  canEdit,
  canView,
  canDelete,
  canDuplicate,
  isArchive,
  anchorEl,
  extraOptions,
  setAnchorEl,
  handleClickButton,
}: Props) => {
  const { t } = useTranslation()

  const options: {
    name: TableMenuOptions
    label?: string
    labelColor?: string
    icon: JSX.Element
    condition?: boolean
  }[] = [
    {
      name: 'edit',
      icon: <Edit fontSize="small" />,
      condition: canEdit,
    },
    {
      name: 'edit',
      label: 'view',
      icon: <Edit />,
      condition: canView,
    },
    {
      name: 'duplicate',
      icon: <FileCopy />,
      condition: canDuplicate,
    },
    {
      name: 'preview',
      icon: <Visibility />,
      condition: canPreview,
    },
    {
      name: 'delete',
      label: isArchive ? 'recover' : 'delete',
      labelColor: isArchive ? undefined : colors.red,
      icon: isArchive ? <Restore /> : <Delete sx={{ color: colors.red }} />,
      condition: canDelete,
    },
  ]

  return (
    <Menu
      {...dropdownMenuProps}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
    >
      {Boolean(extraOptions) && extraOptions}
      {options
        .filter((option) => option.condition)
        .map((option) => (
          <MenuItem
            key={option.name}
            onClick={(event) => handleClickButton(event, option.name)}
          >
            <ListItemIcon>
              {cloneElement(option.icon, {
                fontSize: 'small',
              })}
            </ListItemIcon>
            <ListItemText
              primary={t(`labels.${option.label || option.name}`)}
              sx={{ color: option.labelColor }}
            />
          </MenuItem>
        ))}
    </Menu>
  )
}
